// components/reportCard.jsx
import React from 'react';
import '../../styles/management-report.scss';
import { Users } from 'lucide-react';

class ReportCard extends React.Component {
  render() {
    const {
      icon: Icon,
      className,
      title,
      value,
      enrollment,
      winners,
      // color = 'green', // or 'red', 'yellow', etc.
    } = this.props;

    return (
      <div className={`report-card action`}>
        <div className="report-card-body">
          <div className="report-card-header">{title}</div>
          <div className={`report-card-icon ${className}`}>
            <Icon size={24} />
          </div>
          <div className="report-card-text">
            <div className="report-value">
              <span className="value-label">Auctions</span>
              <span className="value-number">{value}</span>
            </div>
            <div className="report-footer">
              <div className="report-enrollment">
                <Users size={14} />
                <span>enrollment {enrollment}</span>
              </div>
              <div className="report-winners">
                {winners.icon}
                <span>
                  {winners.label} {winners.count}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReportCard;
